module.exports = __webpack_public_path__ + "img/logo.8c0e7528.jpg";